module.exports = __webpack_public_path__ + "img/qq.38510840.png";